import React, { Component } from "react";
import test2 from "../../../resources/test2.jpg";
import star from "../../../resources/star.svg";
import "./Testimonial.css";

function Testimonial() {
  return (
    <div className="homeSectionSevenTestimonials">
      <div className="homeSectionSevenTestimonials__container">
        <div className="homeSectionSevenTestimonial__container__info">
          <div className="homeSectionSevenTestimonial__container__info--img">
            <img src={test2} />
          </div>
          <div className="homeSectionSevenTestimonial__container__info--title">
            <h6>Yessica Christy</h6>
            <p>Shanxi, China</p>
          </div>
          <div className="homeSectionSevenTestimonial__container__info--rating">
            <p>4.5</p>
            <img src={star} />
          </div>
        </div>
        <div className="homeSectionSevenTestimonial__container--comments">
          <p>
            “Wow... I am very happy to use this VPN, it turned out to be more
            than my expectations and so far there have been no problems.
            LaslesVPN always the best”.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Testimonial;
